import { motion } from "framer-motion";

const WakatimeStats = () => {
  return (
    <a style={{ color: "white", flexDirection: "row" }} href="https://wakatime.com/@cff12df3-9cc1-450a-b361-ab9d1902d58e">
      <motion.div
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 2, duration: 0.5 }}
        className="flex items-center space-x-2 mt-8"
      >
        <p className="text-white text-sm">Total time coded since Nov 15 2022 :</p>
        <img src="https://wakatime.com/badge/user/cff12df3-9cc1-450a-b361-ab9d1902d58e.svg" alt="Total time coded since Nov 15 2022" />
      </motion.div>
    </a>
  );
};

export default WakatimeStats;
